import { ReportsAgingWindowData } from 'lib/enums/Reports/AccountingTabEnums';

const getAgingWindowEnumFromDays = (days: number) => {
  if (days < 0) {
    return undefined;
  }
  const roundedDays = Math.ceil(days);
  return Object.values(ReportsAgingWindowData).find(
    window => roundedDays >= window.from && roundedDays <= window.to
  );
};

export const reportsAccountingTabUtils = {
  getAgingWindowEnumFromDays
};
